export default class ModelWithCardsItem {
    constructor() {
        this.init();
    }

    init() {
        this.setupZoomDetection();
    }

    setupZoomDetection() {
        const checkLayoutConditions400 = () => {
            const screenWidth = window.innerWidth;
            const zoomLevel = Math.round((window.outerWidth / window.innerWidth) * 100);
            
            // Condição para zoom 400%: tela <= 1280px E zoom > 300%
            const needsLayoutChanges400 = screenWidth <= 1280 && zoomLevel > 300;
            
            // Aplica classes de zoom 400% nos componentes model-with-cards-item
            const components = document.querySelectorAll('.modelWithCardsItem');
            components.forEach(component => {
                component.classList.toggle('!w-[190px]', needsLayoutChanges400);
            });
        };

        checkLayoutConditions400();
        window.addEventListener('resize', checkLayoutConditions400);
    }
}

// Inicializa quando o DOM estiver pronto
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new ModelWithCardsItem();
    });
} else {
    new ModelWithCardsItem();
}
